import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "controls" ]
  static values = { deleteUrl: String }

  connect() {
    console.log("Hello, Site Element Controller here!", this.element)
  }

  toggleControls(event) {
    this.controlsTarget.classList.toggle("d-none")
  }

  async deleteElement(event) {
    event.preventDefault()

    if (!confirm("Are you sure you want to remove this element from the layout?")) {
      return
    }

    try {
      const response = await fetch(this.deleteUrlValue, {
        method: "DELETE",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
        }
      })

      if (!response.ok && response.status !== 204) {
        throw new Error("Failed to delete element")
      }

      // Remove the element from the DOM with a fade out effect
      this.element.style.transition = "opacity 0.3s"
      this.element.style.opacity = "0"

      setTimeout(() => {
        this.element.remove()
      }, 300)
    } catch (error) {
      console.error("Error deleting element:", error)
      alert("Failed to delete element. Please refresh and try again.")
    }
  }

}
